import { render } from "./BlogPreventiveDentistry.vue?vue&type=template&id=187283d0"
import script from "./BlogPreventiveDentistry.vue?vue&type=script&lang=js"
export * from "./BlogPreventiveDentistry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__